import { Flex, Tag, Typography } from 'antd';
import type { CSSProperties, ReactNode } from 'react';
import { StylingUtility, theme } from '../../../utility';
import type { ReplenishmentLocationRef } from './replenishmentListTypes';

const { Text } = Typography;

function locationTagStyle(color?: string): CSSProperties {
  const base: CSSProperties = {
    margin: 0,
    width: 'fit-content',
    display: 'inline-flex',
    alignItems: 'center',
    lineHeight: 1.25,
    border: 'none',
  };
  if (!color || ['rgb(255,255,255)', '#FFFFFF', '#ffffff'].includes(color)) {
    return {
      ...base,
      backgroundColor: theme.colors.box,
      color: theme.colors.black,
    };
  }
  return {
    ...base,
    backgroundColor: StylingUtility.getLowerOpacityColor(color),
    color,
  };
}

function LocationTag({ color, children }: { color?: string; children: ReactNode }) {
  return <Tag style={locationTagStyle(color)}>{children}</Tag>;
}

type ReplenishmentProductLocationProps = {
  locations?: Array<{ locationId?: ReplenishmentLocationRef }>;
};

export function ReplenishmentProductLocationTags({
  locations,
}: ReplenishmentProductLocationProps) {
  const multiple = (locations?.length ?? 0) > 1;
  const firstLocation = locations?.[0]?.locationId;

  if (multiple) {
    return <LocationTag color="#141414">Multiple</LocationTag>;
  }
  if (!firstLocation) {
    return (
      <Text type="secondary" style={{ fontSize: 14 }}>
        N/A
      </Text>
    );
  }

  return (
    <Flex gap={6} wrap="wrap">
      <LocationTag color={firstLocation.zoneId?.color}>{firstLocation.code}</LocationTag>
      <LocationTag color={firstLocation.zoneId?.color}>
        {firstLocation.zoneId?.code}
      </LocationTag>
    </Flex>
  );
}

export function ReplenishmentLotLocationTags({
  location,
}: {
  location?: ReplenishmentLocationRef;
}) {
  if (!location) {
    return (
      <Text type="secondary" style={{ fontSize: 14 }}>
        N/A
      </Text>
    );
  }

  return (
    <Flex gap={6} wrap="wrap">
      <LocationTag color={location.zoneId?.color}>{location.code || 'N/A'}</LocationTag>
      <LocationTag color={location.zoneId?.color}>
        {location.zoneId?.code || 'N/A'}
      </LocationTag>
    </Flex>
  );
}
